import * as React from "react";
const SvgError = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={256}
    height={256}
    {...props}
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
    >
      <path
        d="M28.5 65.5a4 4 0 0 1-2.829-6.828l33-33a4 4 0 1 1 5.656 5.657l-33 33A3.99 3.99 0 0 1 28.5 65.5"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#ec0000",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="translate(1.407 1.407)scale(2.81)"
      />
      <path
        d="M61.5 65.5a3.99 3.99 0 0 1-2.828-1.172l-33-33a4 4 0 0 1 5.657-5.657l33 33a3.997 3.997 0 0 1 0 5.656A3.99 3.99 0 0 1 61.5 65.5"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#ec0000",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="translate(1.407 1.407)scale(2.81)"
      />
      <path
        d="M45 90C20.187 90 0 69.813 0 45S20.187 0 45 0s45 20.187 45 45-20.187 45-45 45m0-82C24.598 8 8 24.598 8 45s16.598 37 37 37 37-16.598 37-37S65.402 8 45 8"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#ec0000",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="translate(1.407 1.407)scale(2.81)"
      />
    </g>
  </svg>
);
export default SvgError;
